import axios from 'axios'
import axiosCancel from 'axios-cancel'

const isDev = process.env.NODE_ENV === 'development'
let isTokenRefreshing = false
let refreshSubscribers = []

const onTokenRefreshed = (accessToken) => {
    refreshSubscribers.forEach((callback) => callback(accessToken))
}

const addRefreshSubscriber = (callback) => {
    refreshSubscribers.push(callback)
}

const consoleResultStyle = {
    SUCCESS: 'color:green;font-weight:bold',
    INVALID: 'color:orange;font-weight:bold',
    PROBLEM: 'color:red;font-weight:bold',
    CANCELLED: 'color:lightgray;font-weight:bold',
}
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = ''
axios.defaults.paramsSerializer = function(paramObj) {
  const params = new URLSearchParams()
  for (const key in paramObj) {
    if (paramObj[key] !== undefined) {
      params.append(key, paramObj[key])
    }
  }
  return params.toString()
}

// Add a request interceptor
axios.interceptors.request.use(config => {
    // Do something before request is sent
    isDev && console.log(`[API-REQ] ${config.method.toUpperCase()} ${config.baseURL}${config.url}`, { data: config.data, params: config.params, body: config.body })
    return config
}, error => {
    // Do something with request error
    if (isDev && error) {
        if (axios.isCancel(error)) {
            console.log(`[API-REQ] %cCANCELLED`, consoleResultStyle.CANCELLED, error)
        } else {
            console.log(`[API-REQ] %cINVALID`, consoleResultStyle.INVALID, error)
        }
    }
    return Promise.reject(error)
})
// Add a response interceptor
axios.interceptors.response.use(response => {
    // Do something with response data
    if (response.status === 200) {
        isDev && console.log(`[API-RES] %cSUCCESS`, consoleResultStyle.SUCCESS, response.config.method.toUpperCase(), response.config.url)
    }
    return response
}, async error => {
    // Do something with response error
    if (isDev && error) {
        if (axios.isCancel(error)) {
            console.log(`[API-RES] %cCANCELLED`, consoleResultStyle.CANCELLED, error)
        } else {
            console.log(`[API-RES] %cPROBLEM`, consoleResultStyle.PROBLEM, error)
        }
    }

    const {
        config,
        response: { status },
    } = error
    const originalRequest = config

    if (status === 401 && config.url.indexOf('login') === -1 && config.url.indexOf('send-second') === -1 && config.url.indexOf('reissue') === -1) {
        const retryOriginalRequest = new Promise((resolve) => {
            addRefreshSubscriber((accessToken) => {
                originalRequest.headers.Authorization = "Bearer " + accessToken
                resolve(axios(originalRequest))
            })
        })

        if (!isTokenRefreshing) {
            isTokenRefreshing = true
            const accessToken = localStorage.getItem("accessToken")
            const refreshToken = localStorage.getItem("refreshToken")

            try {
                let options = {
                    method: 'POST',
                    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/auth/reissue`,
                    data: {
                        accessToken,
                        refreshToken
                    }
                }

                const response = await axios(options)
                const { accessToken: newAccessToken, refreshToken: newRefreshToken } = response.data

                await localStorage.setItem("accessToken", newAccessToken)
                await localStorage.setItem("refreshToken", newRefreshToken)

                isTokenRefreshing = false
                axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`

                onTokenRefreshed(newAccessToken)
            } catch (error) {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('removeToken')

                return Promise.reject(error)
            }
        }

        return retryOriginalRequest
    }

    return Promise.reject(error)
})
// API 호출 취소를 위해
axiosCancel(axios, {
    debug: false,
})

export default axios
